import { UserType } from '@/modules/user/types';
import { type UserState } from './state';

export const userStore = {
  namespaced: true,
  state: {
    type: UserType.practitioner,
    origin: null
  } as UserState,
  mutations: {
    setOrigin(state: UserState, origin: string | null) {
      state.origin = origin;
    }
  },
  getters: {
    isThirdPartyOrigin: (state: UserState): boolean => state.origin !== null
  }
};
